import * as React from "react";
import { UitkDialogAnimationType, UitkFullscreenDialog } from "uitk-react-dialog";
import { ToolbarType, UitkToolbar } from "uitk-react-toolbar";
import { LinksDialogContext } from "components/flexComponents/Links/GridView/LinkDialogContext";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import Links from "components/flexComponents/Links/Links";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

interface LinkDialogProps {
  id: string;
  context: ExtendedContextStore;
  onDismiss: () => void;
}

export const LinkDialog = (props: LinkDialogProps) => {
  const { id, context, onDismiss } = props;
  const linksDialogContext = LinksDialogContext;

  const keyHelper = new ItemKeyHelper(`LinkDialog-${id}`);

  const dialogProps = {
    dialogShow: true,
    className: "uitk-grid uitk-grid-cell all-cell-1-1",
    animation: UitkDialogAnimationType.SLIDEUP,
  };

  const toolBarAttributes = {
    type: ToolbarType.CLOSE,
    header: linksDialogContext.dialogHeading,
    iconLabel: "Close",
  };

  return (
    <UitkFullscreenDialog {...dialogProps}>
      <div className="uitk-cell">
        <UitkToolbar {...toolBarAttributes} action={onDismiss} />
      </div>
      <div className="LinkDialog uitk-scroll-vertical all-t-padding-one all-y-margin-one all-x-margin-one">
        {linksDialogContext.modules.map((module) => (
          <Links
            key={keyHelper.next()}
            context={context}
            flexComponent={module}
            insideTabGroupWithDialog={true}
            insideTabGroupParam={true}
          />
        ))}
      </div>
    </UitkFullscreenDialog>
  );
};
